import React from 'react';
import PaymentProcess from '../processes/PaymentProcess';

import { observer } from 'mobx-react';

const withAppState = (WrappedComponent, { mobXProps, mobXActions }) => {
  const withAppStateComponent = class extends React.Component {
    render() {
      let innerProps = { ...this.props };

      if (mobXProps) {
        const resolvedMobXProps = mobXProps(PaymentProcess);
        Object.keys(resolvedMobXProps).forEach(key => {
          if (innerProps[key]) throw new Error(`duplicate prop ${key} in withAppState`)
          innerProps[key] = resolvedMobXProps[key];
          if (innerProps[key] === undefined) {
            throw new Error(`withAppState did not find prop ${key} in PaymentProcess`)
          }
          if (typeof innerProps[key] === "function") {
            throw new Error(`withAppState was passed a function as a prop ${key} in PaymentProcess`)
          }
        });
      }
      
      if (mobXActions) {
        const resolvedMobXActions = mobXActions(PaymentProcess);
        Object.keys(resolvedMobXActions).forEach(key => {
          if (innerProps[key]) throw new Error(`duplicate action ${key} in withAppState`)
          innerProps[key] = resolvedMobXActions[key]
          if (innerProps[key]) {
            innerProps[key] = innerProps[key].bind(PaymentProcess);
          } else {
            throw new Error(`withAppState did not find action ${key} in PaymentProcess`)
          }
          if (typeof innerProps[key] !== "function") {
            throw new Error(`withAppState was passed a prop as a function ${key} in PaymentProcess`)
          }
        });
      }

      return <WrappedComponent {...innerProps} />
    }
  }

  return observer(withAppStateComponent);
}

export default withAppState;